import { createTypes } from '../../utils/helpers';

const SERVICES_FETCH: any = createTypes('SERVICES_FETCH');
const SERVICES_UPDATE: any = createTypes('SERVICES_UPDATE');

export { SERVICES_FETCH, SERVICES_UPDATE };
